//@ts-nocheck
"use client";

import React, { useState } from "react";
import styles from "./ccpa.module.css";
import { TbLoaderQuarter } from "react-icons/tb";
import CTABtn from "./cta-btn";
import { handleConsentGiven, saveAndAccept } from "../../utils/ga4noScript";
import Modal from "./modal";
import Loader from "../loader/loader";

interface CCPAFormProps {
    text: string;
}

const CCPAForm: React.FC<CCPAFormProps> = ({ text, openModal = undefined }) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [relationship, setRelationship] = useState("Potential Client / Client");
    const [status, setStatus] = useState("");
    const privacyLink = "https://vxi.com/privacy-policy/";

    const handleSubmit = async (e: React.FormEvent) => {

        e.preventDefault();
        setStatus("loading");

        const subject = "Thank you for your CCPA submission";
        const text = `Hi`;
        const html = btoa(`
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8" />
                <title>Opt-Out Request Received</title>
            </head>
            <body style="margin:0; padding:0; background-color:#f4f6f9; font-family:Arial, sans-serif; color:#333333;">
                <table cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color:#f4f6f9; padding:20px 0;">
                <tr>
                    <td align="center">
                    <table cellpadding="0" cellspacing="0" border="0" width="600" style="background-color:#ffffff; border:1px solid #dddddd; border-radius:6px; padding:20px;">
                        <tr>
                        <td style="font-size:16px; line-height:24px;">
                            <p>
                                Hi <strong><a href="mailto:${email}" style="color:#0066cc; text-decoration:none;">${firstName} ${lastName}</a></strong>,
                            </p>

                            <p>
                            We have received your request, as a <i>${relationship}</i>, to exercise your right to opt out of the sale or sharing of your personal information.
                            </p>

                            <p>
                            Our team is reviewing your request and will process it in accordance with applicable privacy laws. Once the request is completed, we will notify you. In the meantime, please note:
                            </p>

                            <ul style="margin:0 0 16px 20px; padding:0;">
                                <li style="margin-bottom:8px;">We will not sell or share your personal information moving forward once processed.</li>
                                <li style="margin-bottom:8px;">You do not need to take any further action at this time.</li>
                                <li style="margin-bottom:8px;">If we need additional information to verify your request, we will contact you.</li>
                            </ul>

                            <p>
                            If you have any questions about this process, please reach out to us at
                            <a href="mailto:privacy@vxi.com" style="color:#0066cc; text-decoration:none;">privacy@vxi.com</a>
                            or review our <a href="${privacyLink}" style="color:#0066cc; text-decoration:none;">Privacy Policy</a>.
                            </p>

                            <p>Thank you,</p>
                            <p><strong>VXI Global Solutions, LLC<br />Privacy Team</strong></p>
                        </td>
                        </tr>
                    </table>
                    </td>
                </tr>
                </table>
            </body>
            </html>
        `);

        let didTimeout = false;
        // Start a 5-second timer
        const timeoutPromise = new Promise<void>((resolve) => {
            setTimeout(() => {
                didTimeout = true;
                setStatus("✅ Request submitted!");
                saveAndAccept(false, undefined, undefined, handleConsentGiven, true);
                if (typeof openModal === "function") openModal();
                resolve();
            }, 5000);
        });

        try {
            // 1. Log to GCS CSV via /api/collect
            await fetch('/api/collect', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    filename: 'ccpa-submissions.csv',
                    firstName,
                    lastName,
                    email,
                    relationship
                })
            });

            // 2. Send email as before
            const fetchPromise = fetch('/api/send-email-bypass', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    receiver: email,
                    subject,
                    text,
                    html,
                }),
            }).then(async (res) => {
                const data = await res.json();
                if (!didTimeout) {
                    if (data.success) {
                        setStatus('✅ Email sent!');
                        saveAndAccept(false, undefined, undefined, handleConsentGiven, true);
                        if (typeof openModal === 'function') openModal();
                    } else {
                        setStatus(`❌ Failed: ${data.error}`);
                    }
                }
            });

            // Wait for whichever finishes first
            await Promise.race([timeoutPromise, fetchPromise]);
        } catch (err: any) {
            if (!didTimeout) setStatus(`❌ Error: ${err.message}`);
        }

        // setTimeout(() => {
        //     window.location.href = "/home";
        // }, 300);

    };

    return (
        <div className={styles["form-container"]}>
            <div>
                <form onSubmit={handleSubmit}>
                    <fieldset>
                        <div>
                            <label>
                                <span>First Name</span>
                            </label>
                            <div>
                                <input
                                    type="text"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div>
                            <label>
                                <span>Last Name</span>
                            </label>
                            <div>
                                <input
                                    type="text"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <div>
                            <label>
                                <span>Email Address</span>
                            </label>
                            <div>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <div>
                            <label>
                                <span>Relationship</span>
                            </label>
                            <div>
                                <select
                                    value={relationship}
                                    onChange={(e) => setRelationship(e.target.value)}
                                >
                                    <option value="Potential Client / Client">
                                        Potential Client / Client
                                    </option>
                                    <option value="Vendor">Vendor</option>
                                    <option value="Employee">Employee</option>
                                    <option value="Consumer">Consumer</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <div className={styles["submit-container"]}>
                            <CTABtn btnName="Submit" btnURL="/home" passedFunction={handleSubmit} />
                            {status === "loading" && <div className={styles.submit}>
                                <TbLoaderQuarter size={32} color={"#ff6d10"} />
                            </div>}
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    );
};

export default CCPAForm;
